import { render, staticRenderFns } from "./Tabela.vue?vue&type=template&id=3033c3e0&"
import script from "./Tabela.vue?vue&type=script&lang=js&"
export * from "./Tabela.vue?vue&type=script&lang=js&"
import style0 from "./Tabela.vue?vue&type=style&index=0&id=3033c3e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports